import { Injectable } from '@angular/core';
import { BackendState, BackendStatus } from '../interfaces/IBackendState';
import { BehaviorSubject, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BackendStateService {
  #status$ = new BehaviorSubject<BackendStatus | null>(null);

  get status$() {
    return this.#status$;
  }

  loadState() {
    // return this._http.request(AppRequests['backendState']).pipe(
    //   tap((state: BackendState) => {
    //     this.#status$.next(state.status);
    //   }),
    //   catchError(() => {
    //     this.#status$.next('Unhealthy');
    //
    //     return of({ status: 'Unhealthy' });
    //   })
    // );
    return of({ status: 'Unhealthy' });
  }

  setStatusPermanently(status: BackendStatus) {
    this.#status$.next(status);
  }
}
